function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { addListener } from '@domain-group/fe-helper';
import { jsx as ___EmotionJSX } from "@emotion/core";
class MultiResolutionImage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadImage", () => {
      this.removeListeners();
      this.img = new Image();
      this.removeLoadListener = addListener(this.img, 'load', this.handleLoad);
      this.removeErrorListener = addListener(this.img, 'error', this.handleError);
      this.img.src = this.props.src;
    });
    _defineProperty(this, "removeListeners", () => {
      if (this.removeLoadListener) {
        this.removeLoadListener();
      }
      if (this.removeErrorListener) {
        this.removeErrorListener();
      }
    });
    _defineProperty(this, "handleLoad", () => {
      this.setState({
        src: this.props.src
      });
    });
    _defineProperty(this, "handleError", () => {
      this.setState({
        error: true
      });
    });
    _defineProperty(this, "callOnLoad", event => {
      if (event.target.src === this.props.src) {
        this.props.onLoad();
      } else if (event.target.src === this.props.srcLowResolution) {
        this.props.onLoadLowResolution();
      }
    });
    this.state = {
      src: this.props.srcLowResolution || this.props.src,
      error: false
    };
  }
  componentDidMount() {
    if (this.state.src) {
      this.loadImage();
    } else {
      this.handleError();
    }
  }
  componentWillUnmount() {
    this.removeListeners();
  }
  render() {
    if (this.props.fallback && this.state.error) {
      return this.props.fallback;
    }
    return ___EmotionJSX("img", {
      className: this.props.className,
      src: this.state.src,
      alt: this.props.alt,
      onLoad: this.callOnLoad
    });
  }
}
MultiResolutionImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  srcLowResolution: PropTypes.string,
  alt: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  onLoadLowResolution: PropTypes.func,
  fallback: PropTypes.node
};
MultiResolutionImage.defaultProps = {
  className: undefined,
  srcLowResolution: null,
  onLoad: () => {},
  onLoadLowResolution: () => {},
  fallback: undefined
};
export default MultiResolutionImage;